{
  "version": 1,
  "asset_id": "8a12958b-557f-42ce-b469-aa2b6adb39db",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/8a12958b-557f-42ce-b469-aa2b6adb39db/the-siddha-sutra-cover.jpeg",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/8a12958b-557f-42ce-b469-aa2b6adb39db/the-siddha-sutra-cover.jpeg",
  "original_filename": "the-siddha-sutra-cover.jpeg",
  "size": 1410733,
  "content_type": "image/jpeg",
  "created_at": "2026-07-15T00:40:25Z"
}
